<template>
  <!--  车前急救-->
  <div class="recognition-panel">
    <div class="left-part">
      <div class="video-container">
        <div class="video-player">
          <div
            v-for="(item) in remoteStreamList"
            :id="item.getUserId()"
            :key="item.getUserId()"
            class="remote-stream-container"
          />
        </div>
        <div class="video-control"/>
      </div>
      <div class="patient-container">
        <patient-info/>
        <connect-patient
          v-if="icConnected"
          :connect-data="connectedData"
        />
      </div>
      <!-- 本地流区域 -->
      <div v-if="localStream" class="local-stream-container">
        <!-- 本地流播放区域 -->
        <div id="localStream" class="local-stream-content"/>
        <!-- 本地流操作栏 -->
        <div v-if="isPlayingLocalStream" class="local-stream-control">
          <div class="video-control control">
            <span v-if="!isMutedVideo" @click="muteVideo">
              <svg-icon icon-name="video" class="icon-class"/>
            </span>
            <span v-if="isMutedVideo" @click="unmuteVideo">
              <svg-icon icon-name="video-muted" class="icon-class"/>
            </span>
          </div>
          <div class="audio-control control">
            <span v-if="!isMutedAudio" @click="muteAudio">
              <svg-icon icon-name="audio" class="icon-class"/>
            </span>
            <span v-if="isMutedAudio" @click="unmuteAudio">
              <svg-icon icon-name="audio-muted" class="icon-class"/>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="right-part">
      <div>
        <div class="patient-title">
          <span class="title">语音识别</span>
        </div>
        <div class="text-container">
          <div
            v-for="item in recognitionText"
            :key="item.id"
            class="text-content"
          >
            <div class="time">{{ item.time }}</div>
            <div class="car">{{ item.speaker }}</div>
            <div class="content">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="live-desc">
        <div class="patient-title">
          <span class="title">现场描述</span>
        </div>
        <el-input
          v-model="currentMission.live_desc"
          type="textarea"
          :rows="6"
          placeholder="请输入内容"
        />
      </div>
      <div class="button-row">
        <el-button class="confirm-button" @click="saveLiveDescription">保存</el-button>
      </div>
      <div
        class="audio-option"
      >
        <el-select
          v-model="microphoneId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in deviceList"
            :key="item.deviceId"
            :label="item.label"
            :value="item.deviceId"
          />
        </el-select>
      </div>
    </div>
  </div>

</template>

<script>
import PatientInfo from "@components/Drawers/Live/PatientInfo";
import ConnectPatient from "@components/Drawers/Live/ConnectPatient";
import rtc from "@components/trtc/mixins/rtc.js";
import shareRtc from "@components/trtc/mixins/share-rtc.js";
import recognition from "./recognition.js";
import SvgIcon from "@components/common/svg-icon";
import TRTC from "trtc-js-sdk";
import { getTencentToken } from "@api/streamdata";
import { mapState } from "vuex";
import { getTencentAuthentication, saveLiveDesc } from "@api/record";
import { showWindowMessage } from "@utils/notification";
import { getAllUsers } from "@api/user";

export default {
  name: "Recognition",
  components: {
    PatientInfo,
    ConnectPatient,
    SvgIcon
  },
  mixins: [rtc, shareRtc, recognition],

  data() {
    return {
      sdkAppId: "",
      deviceType: "microphone",
      secretKey: "",
      userId: "",
      roomId: "",
      microphoneId: "",
      inviteLink: "",
      logList: [],
      type: "",
      icConnected: true, // 是否已经关联, 关联的数据是:
      currentMission: {},
      deviceList: [],
      liveDesc: "",
      recognitionText: [
        // {
        //   id: 1,
        //   time: "18:09",
        //   text: "如果需要获取 Stream mute 状态，需要监听 Client.on('mute-audio') 事件做进一步处理。",
        //   speaker: "急救车"
        // },
      ], // 语音识别列表
      allUsers: [],
      connectedData: {
        allergy: [
          // "花粉", "布洛芬"
        ],
        latest: [
          // "1, 广州某医院, 看病完毕. 又看了好几次, 没啥大问题.",
          // "2, 北京某医院, 看病完毕. 又看了好几次, 没啥大问题. 但是吧, 后来好像又有点问题!"
        ],
      },
    };
  },
  computed: {
    // isHostMode() {
    //   return this.type !== "invite";
    // },
    ...mapState({
      userInfo: "userInfo",
      currentList: "currentList",
    })
  },
  watch: {
    cameraId(val) {
      this.switchDevice("video", val);
    },
    microphoneId(val) {
      this.switchDevice("audio", val);
    },
  },
  mounted() {
    const id = this.$route.params.id * 1;
    const currentMission = this.currentList.find(({ ambulanceId }) => {
      return ambulanceId === id;
    });
    if (!currentMission) { // 当前急救车没有任务哦
      return;
    }
    this.currentMission = currentMission;

    getAllUsers().then(({ code, data }) => {
      this.allUsers = data;
      const data1 = {
        id: "1aWechat",
        name: "求救人"
      };
      const data2 = {
        id: "1a",
        name: "急救车"
      };
      this.allUsers.push(data1, data2);
    }).catch(e => {
      showWindowMessage(3, e, this);
    });
    /**
     * 房间号生成方法
     * 拿到病历号, 拼接上字符串1, 变成长字符串
     * 再删除前两位 组成10位的字符串
     */
    const number = currentMission.number + "1";
    this.roomId = number.slice(2) * 1;
    this.userId = this.userInfo.id + "";
    // return;
    // this.startAudioRecognition();
    // return;
    // navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(() => {
    navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(() => {
      this.getDeviceList();
    });
    navigator.mediaDevices.addEventListener("devicechange", this.getDeviceList);
  },
  beforeUnmount() {
    navigator.mediaDevices.removeEventListener("devicechange", this.getDeviceList);
    this.handleLeave();
  },
  methods: {
    /**
     * 保存现场表述
     * */
    async saveLiveDescription() {
      const { id, live_desc } = this.currentMission;
      if (!id) {
        showWindowMessage(3, "当前车辆无急救任务", this);
        return;
      }
      try {
        const data = { id, live_desc };
        const { code, msg } = await saveLiveDesc(data);
        showWindowMessage(code === 200 ? 4 : 3, msg, this);
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    async getDeviceList() {
      switch (this.deviceType) {
        case "camera":
          this.deviceList = await TRTC.getCameras();
          break;
        case "microphone":
          this.deviceList = await TRTC.getMicrophones();
          break;
        case "speaker":
          this.deviceList = await TRTC.getSpeakers();
          break;
        default:
          break;
      }
      this.microphoneId = this.deviceList[0]?.deviceId;
      if (!this.microphoneId) {
        alert("没有检测到麦克风, 请先插入麦克风");
      }
      // return;
      await this.handleJoinRoom();
    },
    // 点击【Join Room】按钮
    async handleJoinRoom() {
      const { code, user_sig, sdk_id } = await getTencentToken(this.userInfo.id);
      this.sdkAppId = sdk_id;
      if (code !== 200) {
        alert("从服务器获取音视频密钥失败, 请刷新网页或者联系开发人员");
        return;
      }
      if (!this.roomId) {
        alert("房间号不存在无法加入,请刷新网页或者联系开发人员");
        return;
      }
      this.userSig = user_sig;
      await this.initClient();
      try {
        await this.join();
        await this.initLocalStream();
        await this.playLocalStream();
        await this.publish();
        // await this.startAudioRecognition();
        // this.generateInviteLink();
      } catch (e) {
        console.error(e);
      }
    },
    /* 准备调用腾讯接口，语音识别 */
    async startAudioRecognition(stream) {
      const { code, data, msg, appId } = await getTencentAuthentication();
      if (code !== 200) {
        showWindowMessage(3, msg, this);
        return;
      }
      const { TmpSecretId, TmpSecretKey, Token } = data.Credentials;
      try {
        await this.startRecognitionWork(TmpSecretId, TmpSecretKey, Token, appId, stream);
      } catch (e) {
        showWindowMessage(3, e, this);
        console.log(stream);
      }
    },
    // generateInviteLink() {
    // if (!this.isHostMode) {
    //   return;
    // }
    // const { sdkAppId, secretKey, roomId } = this;
    // const inviteUserId = `user_${parseInt(Math.random() * 100000000, 10)}`;
    // const userSigGenerator = new LibGenerateTestUserSig(sdkAppId, secretKey, 604800);
    // const inviteUserSig = userSigGenerator.genTestUserSig(inviteUserId);
    // this.inviteLink = encodeURI(`${location.origin}${location.pathname}#/invite?sdkAppId=${sdkAppId}&userSig=${inviteUserSig}&roomId=${roomId}&userId=${inviteUserId}`);
    // },
    // 点击【Publish】按钮
    async handlePublish() {
      await this.publish();
    },

    // 点击【Unpublish】按钮
    async handleUnpublish() {
      await this.unPublish();
    },
    // 点击【Leave Room】按钮
    async handleLeave() {
      await this.leave();
    },
    // 显示成功的 Log
    addSuccessLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "success",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },

    // 显示失败的 Log
    addFailedLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "failed",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },
    reportSuccessEvent(name) {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-success`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId,
      // });
    },
    reportFailedEvent(name, error, type = "rtc") {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-failed#${this.roomId}*${type === "share" ? this.shareUserId : this.userId}*${error.message}`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId,
      // });
    },
  }
};

</script>

<style scoped lang='scss'>
.recognition-panel {
  margin-top: 24px;
  display: flex;
}

.video-container {
  width: 658px;
  height: 506px;
  background: #FBFBFB;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .video-player {
    width: 610px;
    height: 402px;
    background: #666666;
    overflow: hidden;
  }

  .video-control {
    width: 610px;
    height: 56px;
    background: #666666;
    opacity: 0.19;
    border-radius: 0 0 10px 10px;
  }
}

.patient-info {
  padding: 24px;
  background: #FBFBFB;
  border-radius: 10px;
  margin-bottom: 0;
  margin-top: 24px;
}

.right-part {
  flex: 1;
  background: #FBFBFB;
  border-radius: 10px;
  margin-left: 22px;
  padding: 24px;
}

::v-deep .patient-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #1783CE;
  }

  .connect {
    font-size: 14px;
    color: #999999;
    cursor: pointer;
  }
}

.text-container {
  height: 360px;
  border-radius: 10px;
  overflow: auto;
  outline: 1px solid #DFDFDF;
  letter-spacing: 2px;
}

.text-content {
  border: 1px solid #EDEDED;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666666;
  padding: 16px 25px;

  .time {
    min-width: 120px;
    padding-top: 3px;
  }

  .car {
    min-width: 100px;
    margin-left: 15px;
  }

  .content {
    color: #333333;
    margin-left: 23px;
  }
}

.live-desc {
  margin-top: 48px;

  .patient-title {
    margin-bottom: 24px;
  }
}

.button-row {
  margin-top: 24px;
  float: right;
}

.patient-container {
  background: #FBFBFB;
  border-radius: 10px;

  .patient-info:nth-child(2) {
    padding-top: 0;
    margin-top: 0;
  }
}
</style>
